import { ENTITY, ENTITY_TO_PATH_MAP } from './entity';

export const LANDING_PAGE_ID_PARAM_NAME = 'landingPageId';
export const LANDING_PAGE_ROUTE = `/${ENTITY_TO_PATH_MAP[ENTITY.LANDING_PAGE]}`;
export const LANDING_PAGE_ID_PARAM_TEMPLATE = `/:${LANDING_PAGE_ID_PARAM_NAME}?`;
